/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import ConfiguraCurso from './ConfiguraCurso';
import {bindActionCreators} from 'redux';
//import * as tagActions from '../../actions/tagActions';
import * as formularioActions from '../../actions/formularioActions';
//import * as resultadoexamenActions from '../../actions/resultadoexamenActions';
import * as moduloActions from '../../actions/moduloActions';
//import * as comentariosActions from '../../actions/comentariosActions';
import * as contenidoActions from '../../actions/contenidoActions';
//import CustomInput from './CustomInput'
//import * as crucigramapalabrasActions from '../../actions/crucigramapalabrasActions';


import {  useParams } from "react-router-dom";
//import {  useLocation, useNavigate  } from "react-router-dom";

import toastr from 'toastr';
import ManageList from '../common/ManageList';
import { Segment, Header} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import ModalFormulario from '../common/ModalFormulario';

import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as cursoActions from '../../actions/cursoActions';
//import * as Resultado from '../common/Resultado';

//import * as infoActions from '../../actions/infoActions';

import {usuarioActual, renuevaToken, validaApiToken} from '../../util';

import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';
import withRouter from '../common/withRouter';

import {getMargenes} from '../../util/';
import moment from 'moment';
import $ from 'jquery';


class ManageCursoView extends React.Component {
    constructor(props, context) {
		
		super(props, context);
    
        this.state={
            errors:{},
            strings:{},
            moduloActivo:false,
            contenidoActivo:false,
            idModuloActivo:0,
            contenidoUpdate:false,
            update:false,
            curso:{
                 modulos:[]
             },
            modulo:{},
            contenidoView:[],
            agrupador:{},
            contenido:[],
            modulos:[],
            showActivos:true,
            showModal:false,
            showModalBorrarModulo:false,
            showModalBorrar:false,
            idModuloContenido:0,
            filtrosCombo:{},
            permisos:{},
            examenSave:{
                cadena:[]
            },
            quiz:{
                
                questions:[]
            },
            visible:true, 
            fechaActual: new moment(),
            fechaComentario:new moment().subtract(5, "days"),
            botonComentario:false,
            dataCrucigrama:{
              across: {},
              down: {}
            },
            dataArray:[],
            imgBanner:{
                imagePreviewUrl:null
            },
            imgThumb:{
                imagePreviewUrl:null
            },
            imgPresentacion:{
                imagePreviewUrl:null
            }
		};
	}
 
    componentDidMount(){
        usuarioActual(this, "cursoview",true).then( (usuario)=>{
            
            let id=this.props.id;

            this.props.cursoActions.getCurso(id, usuario).then( curso=>{
                    
                    let imgPresentacion = this.state.imgPresentacion;
                        
                    if(curso.imagenBannerPresentacion!=null){
                           imgPresentacion.imagePreviewUrl= "/info/resource/?nombre="+curso.imagenBannerPresentacion;
                        
                    }
         
                    this.setState({imgPresentacion:imgPresentacion});
            });
            
            this.cargarModulos(id);
            
        })
        .catch(error=>{
          toastr.error(error);
        });     
            
            
    }
    
    
   
     cargarModulos=(id)=>{
         usuarioActual(this, "cursoview",true).then( (usuario)=>{
        this.props.moduloActions.getModulosList(id, usuario).then((modulo)=>{
                    modulo.update = this.state.update;
                    this.setState({modulos:modulo, update:!this.state.update});
              
                })
                .catch(error=>{
                  toastr.error(error);
                });    
             
         })
        .catch(error=>{
          toastr.error(error);
        });        
        
    }
    
    cargarContenido=(id)=>{
        let contenidoConsulta=[];
        usuarioActual(this, "cursoview",true).then( (usuario)=>{
            this.props.contenidoActions.getContenidosList(id, usuario).then((contenido)=>{
                console.log("aqui");
                contenido.contenidoUpdate  = this.state.contenidoUpdate;
                console.log(contenido);
                this.setState({"contenidoView":contenido, contenidoUpdate:!this.state.contenidoUpdate}); 
                   
            })
            .catch(error=>{
              toastr.error(error);
            });
            
        })
        .catch(error=>{
          toastr.error(error);
        });        
        
     
       
    }
        
    onAcordionModulo=(id)=>{
      
      
        let moduloActivo = this.state.moduloActivo;
        let modulos=    this.state.modulos;
        let indexModulo = modulos.findIndex(modulo=>modulo.idModulo==id); 
        
        this.cargarContenido(id);
        
        moduloActivo=true;
        modulos[indexModulo].activo=true;
        
        let modulo = Object.assign({},modulos[indexModulo] ); 
        this.setState({"moduloActivo":moduloActivo,  modulo:modulo, idModuloActivo:id});
        
    }
    
    
     onAcordionModuloOff=(id)=>{
        
        let moduloActivo = this.state.moduloActivo;
        let modulo = this.state.modulo;
        let contenido =[];
        let modulos=this.state.modulos;
        let contenidoView = [];
        let indexModulo = modulos.findIndex(modulo=>modulo.idModulo==id);
        
        moduloActivo=false;
        //contenidoActivo=false;
        modulos[indexModulo].activo=false;
        modulo=[];
        
        this.setState({"moduloActivo":moduloActivo,  modulo:modulo, idModuloActivo:0}); //"contenidoView":contenidoView,
        //this.setState({"contenidoActivo":contenidoActivo, "contenido":contenido});
        
    } 
    
    onAcordionContenido=(id)=>{
        /*
        let contenidoActivo = true;
        let indexModulo = this.state.modulo.contenidoView.findIndex(contenido=>contenido.agrupador==id);
        let contenido = Object.assign([],this.state.modulo.contenidoView[indexModulo].contenido); 



        let agrupador = this.state.agrupador;

        agrupador.titulo = contenido[0].agrupador;
        agrupador.fecha = contenido[0].fecha;

        this.setState({"contenidoActivo":contenidoActivo, "contenido":contenido, agrupador:agrupador});
        */
    }
  
  
    onAcordionContenidoOff=(id)=>{
        /*
        let contenidoActivo=false;
        let contenido=[];
        let agrupador=this.state.agrupador;
        agrupador={};

        this.setState({"contenidoActivo":contenidoActivo, "contenido":contenido, agrupador:agrupador});
        */
    }
    
     onShowModal=(titulo, tipoFormulario, id=0)=>{
         

        this.setState({idModulo:id});
        this.setState({showModal:true});
        this.setState({titulo:titulo});
        this.setState({tipoFormulario:tipoFormulario});
         
        //console.log(this.state.idModuloActivo); 
        
    }
     
     onCloseModal=()=>{
         
        this.cargarModulos(this.props.id); 
        this.setState({showModal:false});
        
    }

    
    onSaveOrden=()=>{
    
        let modulos=Object.assign([], this.state.modulos);
        let cursoModulo={};
        let cursoModuloListUI=[];
        
        for(let i=0; i<modulos.length; i++){
            cursoModulo={};            
            cursoModulo.idCurso = this.props.id;
            cursoModulo.idModulo = modulos[i].idModulo;
            cursoModulo.orden = modulos[i].index+1;
            cursoModuloListUI.push(cursoModulo);    
        }
        
        this.props.moduloActions.saveModuloCursoOrden(cursoModuloListUI, this.props.user).then(() => {
            toastr.success("Orden de módulos guardado!!!.");
            this.cargarModulos(this.props.id);
        });
        
    }
        
    
     onSaveOrdenModulo=()=>{
        
        //console.log(this.state.contenidoView);
        //console.log(this.state.modulo);
        //console.log(this.state.moduloActivo);
        /*
        let modulos=Object.assign([], this.state.curso.modulos);
        //console.log(modulos);
        let moduloContenido={};
        let cursoModuloListUI=[];
        
        for(let i=0; i<modulos.length; i++){
            moduloContenido={};
            moduloContenido.idCurso = this.props.id;
            moduloContenido.idModulo = modulos[i].id;
            moduloContenido.orden = modulos[i].index+1;
            cursoModuloListUI.push(moduloContenido);
            
        }
        
        
        this.props.moduloActions.saveModuloCursoOrden(cursoModuloListUI, this.props.user).then(() => {
            toastr.success("Orden de módulos guardado!!!.");
        });
        */
      
        
    }
    
    onSaveOrdenContenido=()=>{
        
        let contenido=Object.assign([], this.state.contenidoView);
        let moduloContenido={};
        let moduloContenidoListUI=[];
        
        //console.log(contenido);
    
        
        for(let i=0; i<contenido.length; i++){
            moduloContenido={};
            moduloContenido.idContenido = contenido[i].idContenido;
            moduloContenido.idModulo = contenido[i].idModulo;
            moduloContenido.id = contenido[i].id
            moduloContenido.orden = contenido[i].index+1;
            moduloContenidoListUI.push(moduloContenido);
            
        }
        
      
        this.props.moduloActions.saveModuloContenidoOrden(moduloContenidoListUI, this.props.user).then(() => {
            toastr.success("Orden de contenido guardado!!!.");
        });
        
    }
    
     onHandleChangeFile=(event, data)=> {
        let tamano;
        let imagen = this.state.imgPresentacion;
        let field= data.name;		
        let value;

        let file = event.target.files[0];
        if (!file){
            imagen.fileReg = '';
            imagen.imagePreviewUrl='';

            this.setState({"fileReg": ''});
            this.setState({"imgPresentacion": imagen});
            return;
        }


        if(event.target.files[0].size<=(1024*1024)*2){
            imagen['fileReg'] = event.target.files[0];
            imagen['imagePreviewUrl'] = URL.createObjectURL(event.target.files[0]);
            this.setState({"fileReg": '1'});
            this.setState({"imgPresentacion": imagen});
           
        }else{
            tamano= Number(event.target.files[0].size)/Number(1048576);
            imagen.fileReg = '';
            imagen.imagePreviewUrl='';
            this.setState({"fileReg": ''});
            this.setState({"imgPresentacion": imagen});
            toastr.error("El archivo que intenta anexar mide "+tamano.toFixed(2)+"Mb. No se permiten imagnees mayores a 5 Mb!!!");
            return;
        } 
         
     }
     
     onEliminar=(id)=>{
          
         this.setState({idModuloContenido:id});
         this.setState({showModalBorrar:true});
     }
     
     oncloseModal=()=>{
        
         this.setState({idModuloContenido:0});
         this.setState({showModalBorrar:false});
     }
     
     onBorrarContenido=()=>{
      
         
         this.props.moduloActions.borrarMC(this.state.idModuloContenido, this.props.user).then(() => {
                toastr.success("Contenido eliminado");
                this.cargarContenido(this.state.idModuloActivo);
                this.oncloseModal();
                
        });
         
        
     }
     
     
        
     onEliminarModulo=(id)=>{
          
         this.setState({idModuloActivo:id});
         this.setState({showModalBorrarModulo:true});
     }
     
     oncloseModalModulo=()=>{
        
         this.setState({idModuloActivo:0});
         this.setState({showModalBorrarModulo:false});
     }
     
     onBorrarModulo=()=>{
      
         
         this.props.moduloActions.borrar(this.state.idModuloActivo, this.props.user).then(() => {
                toastr.success("Modulo eliminado");
                this.cargarModulos(this.props.id);
                this.oncloseModalModulo();
                
        });
         
        
     }
     
     
     onSaveImage=(event)=>{
          
            var image = this.state.imgPresentacion.fileReg;
            if(image instanceof File){

                var form_data = new FormData();
                form_data.append('file', image);
                form_data.append('tipo', 'imgPresentacion');
                form_data.append('id', this.props.id);

                this.props.cursoActions.saveImagen(form_data, this.props.user).then((imagen) => {

                    toastr.success("Imagen guardada correctamente!!!.");

                }).catch(error=>{
                  toastr.error(error.responseJSON.message);
                });

            }
    }
     
      render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
        
     	return (
            <Segment>
                 
                <ConfiguraCurso
                    modulos={this.state.modulos}
                    strings={this.props.strings}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    permisos={this.state.permisos}
                    visible={this.state.visible}
                    onVisible={this.onVisible}
                    id={this.state.id}
                    regresar={this.regresar}
                    quiz={this.state.quiz}
                    setQuizResult={this.setQuizResult}
                    renderCustomResultPage={this.renderCustomResultPage}
                    comentarios={this.state.comentarios}
                    onShowModal={this.onShowModal}
                    fechaActual={this.state.fechaActual}
                    handleClick={this.handleClick}
                    videoProgreso={this.videoProgreso}
                    onDuration={this.handleDuration}
                    videoTerminado={this.onVideoTerminado}
                    fechaComentario={this.state.fechaComentario}
                    errorExamen={this.state.err}
                    saveExamen={this.saveExamen} 
                    dataCrucigrama={this.state.dataCrucigrama}
                    dataArray={this.state.dataArray}
                    goBack={this.goBack}
                    handleChangeFile={this.onHandleChangeFile}
            
                    moduloActivo={this.state.moduloActivo}
                    onAcordionModulo={this.onAcordionModulo}
                    onAcordionModuloOff={this.onAcordionModuloOff}    
                    contenidoView={this.state.contenidoView}
                    modulo={this.state.modulo}
                    onAcordionContenido={this.onAcordionContenido}
                    contenidoActivo={this.state.contenidoActivo}
                    contenido={this.state.contenido}
                    agrupador={this.state.agrupador}
                    onAcordionContenidoOff={this.onAcordionContenidoOff}
                
                    onSaveOrden={this.onSaveOrden}
                    onSaveOrdenModulo={this.onSaveOrdenModulo}
                    onSaveOrdenContenido={this.onSaveOrdenContenido}     
            
            
                    saveImage={this.onSaveImage}
                    imgPresentacion={this.state.imgPresentacion}
                    //imgThumb={this.state.imgThumb}
                    //imgPresentacion={this.state.imgPresentacion}
                    onEliminar={this.onEliminar}
                    onEliminarModulo={this.onEliminarModulo}
            
                />
            
                <ModalFormulario 
                    showModal={this.state.showModal}
                    tipoFormulario={this.state.tipoFormulario}
                    closeModal={this.onCloseModal}
                    titulo={this.state.titulo}
                    modulo={this.state.modulo}
                    idCurso={this.props.id}
                    idModulo={this.state.idModulo}
                    contenidoView={this.state.contenidoView}
                    cargarModulos={this.cargarModulos}
                    cargarContenido={this.cargarContenido}
                    idModuloActivo={this.state.idModuloActivo}
                />
                
                <ModalSiNo
                    showModal={this.state.showModalBorrar}
                    closeModal={this.oncloseModal}
                    borrar={this.onBorrarContenido}
                    icono={"trash"}
                    texto={"Esta seguro que desea eliminar este contenido?"}
                    titulo={this.state.strings?this.state.strings["Contenido"]:""}
                />
            
                <ModalSiNo
                    showModal={this.state.showModalBorrarModulo}
                    closeModal={this.oncloseModalModulo}
                    borrar={this.onBorrarModulo}
                    icono={"trash"}
                    texto={"Esta seguro que desea eliminar este módulo?"}
                    titulo={this.state.strings?this.state.strings["modulo"]:""}
                />
                
            
            </Segment> 
            
		);
	}
    
    
}


function mapStateToProps(state, ownProps){
    return {
          

        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        color:state.color,
        strings:state.strings,
        idioma:state.idioma,
        user:state.user
    }

}


function mapDispatchToProps(dispatch){

	return { 
        menuActions:bindActionCreators(menuActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        //infoActions: bindActionCreators(infoActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        formularioActions: bindActionCreators(formularioActions, dispatch),
        //resultadoexamenActions: bindActionCreators(resultadoexamenActions, dispatch),
        //comentariosActions: bindActionCreators(comentariosActions, dispatch),
        contenidoActions: bindActionCreators(contenidoActions, dispatch),
        //crucigramapalabrasActions: bindActionCreators(crucigramapalabrasActions, dispatch),
        moduloActions: bindActionCreators(moduloActions, dispatch)
 	};
}




export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCursoView));